<template>
    <div>
        <v-row>
            <v-text-field v-model="search"
                density="compact"
                placeholder="Pesquisa..."
            >
            </v-text-field>
            <v-btn-small icon @click="saveAsTxt"><v-icon>mdi-download</v-icon></v-btn-small>
            <v-switch class="ml-4" density="compact" label="Notif. Sonora" v-model="enableNotify" color="primary"></v-switch>
        </v-row>
        <v-virtual-scroll class="gw" id="gw" height="70vh" :items="computedLogs">
            <template v-slot:default="data">
                <div :class="`item-gw item-gw-priority-${data.item.priority} item-gw-${data.index}`">
                    <div>
                        <samp style="color: grey">{{data.item.date_time}} - {{data.item.priority}}</samp> - <samp style="color: white">{{data.item.user}}</samp>
                    </div>
                    <div>
                        <samp style="color: grey">{{data.item.app}}</samp> - <samp style="color: green">{{data.item.message}}</samp>
                    </div>
                </div>
                <v-divider v-if="data.index == 0" class="my-4"></v-divider>
            </template>
        </v-virtual-scroll>
        <ws-gdb ws_channel="channel_gateway"
            app="gateway"
            @on-message="onMessageWebSocket"/>
    </div>
</template>
<script>
export default {
    data:()=>({
        search: null,
        logs:[],
        enableNotify: false,
        enableScroll: true
    }),
    mounted(){
    },
    methods:{
        notificarSom(){
            // Cria um objeto de áudio
            const audio = new Audio('/audio/error.mp3');
                // Reproduz o som
                audio.play()
        },
        onMessageWebSocket(value){
            this.logs = [value,...this.logs]
            if(value.notify && this.enableNotify){
                this.notificarSom()
            }
        },
        saveAsTxt() {
            // Obter o conteúdo da div
            const content = document.getElementById('gw').innerText;

            // Criar um Blob com o conteúdo da div
            const blob = new Blob([content], { type: 'text/plain' });

            // Criar um link de download
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'gateway.txt';

            // Clicar no link de download programaticamente
            link.click();

            // Liberar o objeto URL
            URL.revokeObjectURL(link.href);
        }
    },
    computed: {
        computedLogs(){
            if (!this.search)
                return this.logs
            return this.logs.filter(o => o.html.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
        }
    }
}
</script>
<style scoped>
.gw{
    background: black;
    border-radius: 5px;
    padding: 10px;
}
.item-gw{
    padding-left: 10px;
    margin: 9px 0;
}
.item-gw-0{
    padding: 20px 20px 20px 10px;
    margin: 9px 0;
}
.item-gw-priority-0{
    border-left: green 5px solid;
}
.item-gw-priority-1{
    border-left: rgb(231, 189, 0) 5px solid;
}
.item-gw-priority-2{
    border-left: rgb(233, 0, 0) 5px solid;
}
</style>